// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-responsive {
  width: 100%;
  overflow-x: auto;
  margin: 0 auto;
  border-collapse: collapse;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.custom-table thead {
  background-color: #36f !important;
  color: white;
  font-weight: 700;
  text-align: left;
  position: sticky;
  top: 0;
  z-index: 10;
  padding: 13px 10px !important;
}

th,
td {
  padding: 13px 10px !important;
  border: 1px solid #ddd;
  text-align: left;
  color: inherit;
  text-decoration: none;
}

th {
  position: sticky;
  top: 0;
}

.parent td {
  background-color: #f2feff !important;
  font-weight: bold;
  padding: 13px 10px !important;
}

.child td {
  background-color: #eefaff !important;
  padding: 13px 10px !important;
}

.agent-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid darkgray;
}

.dtr-details {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.dtr-title {
  color: #2a62ff;
  display: inline-block;
  font-weight: bold;
  width: 350px !important;
  padding-left: 8% !important;
}

.dtr-title:after {
  content: " : ";
}

.tree {
  list-style-type: none;
  padding-left: 3%;
  position: relative;
}

.tree li {
  list-style-type: none;
  margin: 10px 0;
  position: relative;
  padding-left: calc(20px + var(--level, 0) * 40px);
}

.tree li::before {
  content: "";
  position: absolute;
  top: -15px !important;
  left: calc(var(--level, 0) * 40px + 65px);
  width: 20px;
  height: 80%;
  border-left: 2px solid #ccc;
  border-bottom: 2px solid #ccc;
}

.tree li:first-child::before {
  border: none;
}

.tree li:last-child::before {
  height: 80%;
  left: calc(var(--level, 0) * 40px + 65px);
}

.tree a {
  text-decoration: none;
  color: #333;
  display: flex;
  align-items: center;
  font-weight: bold;
  padding: 0px 0px 5px 65px;
}

.tree img {
  margin-right: 10px;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  border: 2px solid #ccc;
  z-index: 2;
}

.btnIcons {
  background-color: #36f;
  color: white;
  border-radius: 20px;
}

.dtr-data {
  padding-left: 10% !important;
}`, "",{"version":3,"sources":["webpack://./src/app/hierarchy/my-team-details/my-team-details.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AACF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;AACF;;AAEA;EACE,iCAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,6BAAA;AACF;;AAEA;;EAEE,6BAAA;EACA,sBAAA;EACA,gBAAA;EAEA,cAAA;EACA,qBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,MAAA;AAAF;;AAGA;EACE,oCAAA;EACA,iBAAA;EACA,6BAAA;AAAF;;AAGA;EACE,oCAAA;EACA,6BAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;AAAF;;AAGA;EACE,qBAAA;EACA,SAAA;EACA,UAAA;AAAF;;AAGA;EACE,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,uBAAA;EACA,2BAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,qBAAA;EAEA,gBAAA;EACA,kBAAA;AADF;;AAIA;EACE,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,iDAAA;AADF;;AAIA;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,yCAAA;EACA,WAAA;EACA,WAAA;EACA,2BAAA;EACA,6BAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,WAAA;EACA,yCAAA;AADF;;AAIA;EACE,qBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;AADF;;AAIA;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;AADF;;AAIA;EACE,sBAAA;EACA,YAAA;EACA,mBAAA;AADF;;AAIA;EACE,4BAAA;AADF","sourcesContent":[".table-responsive {\n  width: 100%;\n  overflow-x: auto;\n  margin: 0 auto;\n  border-collapse: collapse;\n}\n\n.custom-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n\n.custom-table thead {\n  background-color: #36f !important;\n  color: white;\n  font-weight: 700;\n  text-align: left;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  padding: 13px 10px !important;\n}\n\nth,\ntd {\n  padding: 13px 10px !important;\n  border: 1px solid #ddd;\n  text-align: left;\n  //   white-space: nowrap;\n  color: inherit;\n  text-decoration: none;\n}\n\nth {\n  position: sticky;\n  top: 0;\n}\n\n.parent td {\n  background-color: #f2feff !important;\n  font-weight: bold;\n  padding: 13px 10px !important;\n}\n\n.child td {\n  background-color: #eefaff !important;\n  padding: 13px 10px !important;\n}\n\n.agent-image {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 2px solid darkgray;\n}\n\n.dtr-details {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n.dtr-title {\n  color: #2a62ff;\n  display: inline-block;\n  font-weight: bold;\n  width: 350px !important;\n  padding-left: 8% !important;\n}\n\n.dtr-title:after {\n  content: ' : ';\n}\n\n.tree {\n  list-style-type: none;\n  // padding-left: 0;\n  padding-left: 3%;\n  position: relative;\n}\n\n.tree li {\n  list-style-type: none;\n  margin: 10px 0;\n  position: relative;\n  padding-left: calc(20px + var(--level, 0) * 40px);\n}\n\n.tree li::before {\n  content: '';\n  position: absolute;\n  top: -15px !important;\n  left: calc(var(--level, 0) * 40px + 65px);\n  width: 20px;\n  height: 80%;\n  border-left: 2px solid #ccc;\n  border-bottom: 2px solid #ccc;\n}\n\n.tree li:first-child::before {\n  border: none;\n}\n\n.tree li:last-child::before {\n  height: 80%;\n  left: calc(var(--level, 0) * 40px + 65px);\n}\n\n.tree a {\n  text-decoration: none;\n  color: #333;\n  display: flex;\n  align-items: center;\n  font-weight: bold;\n  padding: 0px 0px 5px 65px;\n}\n\n.tree img {\n  margin-right: 10px;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  border: 2px solid #ccc;\n  z-index: 2;\n}\n\n.btnIcons {\n  background-color: #36f;\n  color: white;\n  border-radius: 20px;\n}\n\n.dtr-data {\n  padding-left: 10% !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
